import axios from "axios";
import { API } from "@/App";

export const guideApi = {
  categories: () => axios.get(`${API}/guide/categories`).then((r) => r.data),
  featured: () => axios.get(`${API}/guide/featured`).then((r) => r.data),
  list: (params = {}) => axios.get(`${API}/guide/articles`, { params }).then((r) => r.data),
  search: (q) => axios.get(`${API}/guide/search`, { params: { q } }).then((r) => r.data),
  get: (slug) => axios.get(`${API}/guide/article/${slug}`).then((r) => r.data),
};

// Map of category icon names (lucide-react component names) — used by frontend
export const CAT_ICONS = {
  Globe: "Globe", IdCard: "IdCard", Flag: "Flag", Hash: "Hash", Receipt: "Receipt",
  Home: "Home", Landmark: "Landmark", TrendingUp: "TrendingUp", Briefcase: "Briefcase",
  Scale: "Scale", Heart: "Heart", HandCoins: "HandCoins", Apple: "Apple", Baby: "Baby",
  Building: "Building", GraduationCap: "GraduationCap", Car: "Car", Store: "Store",
  ShieldCheck: "ShieldCheck", Users: "Users", Siren: "Siren",
};
